import {
    pollPrimaVideoLaunch,
    revertReplacedTagsOfArticleScripts,
} from 'mk2/apps/wiki/containers/PrimaEmbed/PrimaEmbed.helpers';
import { getLogger } from 'mk2/logger';
import React, { useEffect, useRef, useState } from 'react';

const logger = getLogger('wiki.PrimaEmbed');

export const PrimaEmbed = ({ scripts }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [uniqueId] = useState(() => `prima-embed-${Math.random().toString(36).substr(2, 8)}`);

    useEffect(() => {
        if (!scripts || !containerRef.current) return;

        const target = containerRef.current;
        target.innerHTML = '';
        document.querySelectorAll('[data-article-script]').forEach(el => el.remove());

        const html = revertReplacedTagsOfArticleScripts(scripts);
        const tmpContainer = document.createElement('div');
        tmpContainer.innerHTML = html;

        // append non-script nodes
        tmpContainer.childNodes.forEach(node => {
            if (node.nodeName.toLowerCase() !== 'script') {
                target.appendChild(node.cloneNode(true));
            }
        });

        // append script tags
        tmpContainer.querySelectorAll('script').forEach(script => {
            const newScript = document.createElement('script');
            const src = script.getAttribute('src');
            if (src) {
                newScript.src = src;
                newScript.type = script.type || 'text/javascript';
                newScript.async = true;
            } else if (script.textContent) {
                newScript.textContent = script.textContent;
            }
            newScript.setAttribute('data-article-script', '');
            target.appendChild(newScript);
        });

        pollPrimaVideoLaunch(uniqueId, 20, 500);

        return () => {
            target.innerHTML = '';
            document.querySelectorAll('[data-article-script]').forEach(el => el.remove());
        };
    }, [scripts, uniqueId]);

    return <div ref={containerRef} id={uniqueId} className="prima-embed-container" />;
};
